import { render, staticRenderFns } from "./D_SettingForm.vue?vue&type=template&id=3e71a5be&scoped=true&"
import script from "./D_SettingForm.vue?vue&type=script&lang=js&"
export * from "./D_SettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e71a5be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e71a5be')) {
      api.createRecord('3e71a5be', component.options)
    } else {
      api.reload('3e71a5be', component.options)
    }
    module.hot.accept("./D_SettingForm.vue?vue&type=template&id=3e71a5be&scoped=true&", function () {
      api.rerender('3e71a5be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/setting/D_SettingForm.vue"
export default component.exports